import { useMemo } from 'react';
import { ActivityType, useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, ICustomPageExpenseInfoDto } from '@/dtos';
import {
  SearchTransactionParams,
  Transaction,
} from '@/modules/transaction/transaction.types';

const QUERY_KEY = 'transactionsList';

export const useExpensesList = (searchParams: SearchTransactionParams) => {
  const { isLoading, error, data, isSuccess, refetch } = useQuery([QUERY_KEY, searchParams], () =>
    api.get<ICustomPageExpenseInfoDto>(API_URL.EXPENSES, {
      params: { ...searchParams },
    })
  );

  const formattedData = useMemo(
    () =>
      data?.data?.content?.map((item): Transaction => {
        const formattedItem: Transaction = {
          categoryType: item?.category_type as unknown as ActivityType,
          paidAmount: item.paid_amount || 0,
          provider: item.provider_name || '',
          requestedAmount: item.requested_amount || 0,
          status: item.status || '',
          statusDate: item.status_date as unknown as string,
          claimId: toString(item.claim_id),
        };
        return formattedItem;
      }),
    [data]
  );

  return {
    data: formattedData || [],
    // @ts-ignore
    total: data?.data?.total_elements || data?.data?.totalElements || 0,
    error,
    isLoading,
    isSuccess,
    refetch,
  };
};
